module.exports = __webpack_public_path__ + "static/media/ramon-deenen-1.a952578b.jpg";